import { render, staticRenderFns } from "./el-form-item.vue?vue&type=template&id=3ef6bbe0&scoped=true"
import script from "./el-form-item.vue?vue&type=script&lang=js"
export * from "./el-form-item.vue?vue&type=script&lang=js"
import style0 from "./el-form-item.vue?vue&type=style&index=0&id=3ef6bbe0&prod&scoped=true&lang=css"
import style1 from "./el-form-item.vue?vue&type=style&index=1&id=3ef6bbe0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef6bbe0",
  null
  
)

export default component.exports